/* global moment swal angular */

import './style.less';

export default function($log, $stateParams, ApiClass, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const { company_id, profile_uid } = ProfileClass.profileComplete.profile;

  vm.profile_uid = profile_uid;

  function activate() {
    $log.debug('Form activated');
    vm.loaded = false;
    vm.error = {};

    if (!$stateParams.formId) return (vm.loaded = true);

    ApiClass.companiesIdTypeTypeIdGet(
      {
        manage: false,
        id: company_id,
        type: 'forms',
        type_id: $stateParams.formId
      },
      null,
      { queryParams: {} }
    )
      .then(({ data: { item: form } }) => {
        const { description, jotFormId, name } = form;

        vm.description = description;
        vm.jotFormId = jotFormId;
        vm.name = name;

        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/forms/form/controller.js